var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Blood Pressure")]),_c('div',{staticClass:"route"},[_c('router-view')],1),_c('Nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }